export async function createPayment(customerId: string) {
  // const BASE_URL = "http://localhost:7071/api/create-payment";
  const BASE_URL =
    process.env.REACT_APP_BUILD_ENVIRONMENT !== "development"
      ? "https://jurisageapi.azurewebsites.net/api/create-payment"
      : "https://jurisageapi-staging.azurewebsites.net/api/create-payment";

  const resp = await fetch(BASE_URL, { method: "POST", body: JSON.stringify({ customerId: customerId }) });
  const data = await resp.json();
  return Promise.resolve(data);
}
export async function updatePayment(paymentIntent: string, authData: object) {
  // const BASE_URL = "http://localhost:7071/api/update-payment";
  const BASE_URL =
    process.env.REACT_APP_BUILD_ENVIRONMENT !== "development"
      ? "https://jurisageapi.azurewebsites.net/api/update-payment"
      : "https://jurisageapi-staging.azurewebsites.net/api/update-payment";
  const resp = await fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({ paymentIntent: paymentIntent, ...authData }),
  });
  const data = await resp.json();

  return Promise.resolve(data);
}

// Create stripe customer after signup is successful
export async function createStripeCustomer(authData: object) {
  // const BASE_URL = "http://localhost:7071/api/create-stripe-customer";
  const BASE_URL =
    process.env.REACT_APP_BUILD_ENVIRONMENT !== "development"
      ? "https://jurisageapi.azurewebsites.net/api/create-stripe-customer"
      : "https://jurisageapi-staging.azurewebsites.net/api/create-stripe-customer";
  const resp = await fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({ ...authData }),
  });
  const data = await resp.json();

  return Promise.resolve(data);
}

export async function getStripeCustomer(Id: string) {
  // const BASE_URL = "http://localhost:7071/api/get-stripe-customer";
  const BASE_URL =
    process.env.REACT_APP_BUILD_ENVIRONMENT !== "development"
      ? "https://jurisageapi.azurewebsites.net/api/get-stripe-customer"
      : "https://jurisageapi-staging.azurewebsites.net/api/get-stripe-customer";
  const resp = await fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({ Id }),
  });
  const data = await resp.json();

  return Promise.resolve(data);
}

export async function assignAuthPermissions(paymentIntent: string) {
  // const BASE_URL = "http://localhost:7071/api/ad/assign-ad-permissions";
  const BASE_URL =
    process.env.REACT_APP_BUILD_ENVIRONMENT !== "development"
      ? "https://jurisageapi.azurewebsites.net/api/ad/assign-ad-permissions"
      : "https://jurisageapi-staging.azurewebsites.net/api/ad/assign-ad-permissions";
  const resp = await fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({ paymentIntent: paymentIntent }),
  });
}
